import { useDeleteAlert } from '@/composables'

export default {
	data() {
		return {
			reception_flow_data: {
				flow_type: null,
				temp_attendance_id: null,
				patient_id: null,
				is_finishable: false,
				is_finished: false,
			},
		}
	},
	computed: {
		isReceptionFlow() {
			return !!this.reception_flow_data?.flow_type
		},
	},
	methods: {
		async CancelFlow() {
			this.SendToParent({
				type: 'RECEPTION_FLOW_CANCELLED',
				payload: {
					flow_type: this.reception_flow_data?.flow_type,
					patient_id: this.reception_flow_data?.patient_id,
					temp_attendance_id:
						this.reception_flow_data?.temp_attendance_id,
				},
			})
		},
		FinishFlow() {
			this.reception_flow_data.is_finished = true

			this.SendToParent({
				type: 'RECEPTION_FLOW_FINISHED',
				payload: {
					flow_type: this.reception_flow_data?.flow_type,
					patient_id: this.reception_flow_data?.patient_id,
					temp_attendance_id:
						this.reception_flow_data?.temp_attendance_id,
				},
			})
		},
		SendToParent(message, targetOrigin) {
			const origin = targetOrigin || window.location.origin

			window.opener?.postMessage(message, origin)
		},
		HandleReceptionFlow() {
			this.reception_flow_data = this.$route?.query?.reception_flow_data
				? JSON.parse(this.$route?.query?.reception_flow_data)
				: {}
		},
	},
}
